import { IconButton } from '@mui/material';
import React, { ReactElement, useEffect, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { NamedEntity } from '../../../types/entities/NamedEntity';
import { SchemaWithClient } from '../../../types/SchemaWithClient';
import { Autocomplete, Chip, Popper, TextField, Button } from '@mui/material';
import Box from '@mui/material/Box';
import ColorizeIcon from '@mui/icons-material/Colorize';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import { SlidingPaneAddNew } from '../../Page/SlidingPaneAddNew';
import { SlidingPaneEdit } from '../../Page/SlidingPaneEdit';
import LargePopper from '../assets/LargePopper';
import AddIcon from "@mui/icons-material/Add";

type Props<T extends NamedEntity> = {
  onChange: (value: any) => void;
  schema: any;
  defaultValue: any;
  forcedValue: any;
  disabled: boolean;
  isMissing: boolean;
  mainSchema: any;
  column: any;
  accordingToValue: any;
  allValue: any;
  moreOptions: any;
};

export const SPSetField = <T extends NamedEntity>({
  onChange,
  defaultValue,
  forcedValue,
  disabled,
  isMissing,
  schema,
  mainSchema,
  column,
  accordingToValue,
  allValue,
  moreOptions,
}: Props<T>): ReactElement | null => {
  const [addingEntity, setAddingEntity] = useState<any>(undefined);
  const [loading, setLoading] = useState(false);
  const [selectOptions, setSelectOptions] = useState<any>([]);

  const [currentState, setCurrentState] = useState<any>({
    value: null,
    send: false,
  });

  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({});

  useEffect(() => {
    if (
      typeof defaultValue !== undefined &&
      defaultValue !== null &&
      defaultValue !== undefined
    ) {
      setSelectOptions(defaultValue);
    }
  }, []);

  const fetchSelectOptions = async (
    searchText: string,
    columnName?: string,
    row?: any
  ) => {
    setLoading(true);

    const searchParams = new URLSearchParams({
      searchValue: searchText,
    });

    if (mainSchema && mainSchema.name === 'Service Group') {
      if (column?.name === 'Services') {
        searchParams.append(
          'serviceProvider',
          JSON.stringify(allValue?.service_provider?.id)
        );
      }
    }

    schema.client.readAll(1, searchParams).then((result: any) => {
      result.data.unshift({ id: 0, name: '', isButton: true });
      setSelectOptions(result.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    setCurrentState({
      value: defaultValue,
      send: false,
    });
  }, [defaultValue]);

  useEffect(() => {
    if (currentState.send) {
      onChange(currentState.value);
    }
  }, [currentState]);

  const handleOnChange = (value: any) => {
    let isReturn = false;
    value.filter((item: any) => {
      if (item?.isButton) {
        isReturn = true;
      }
      return !item?.isButton;
    });

    if (isReturn) {
      setAddingEntity(true);
    } else {
      setCurrentState({
        value: value,
        send: true,
      });
    }
  };
  const CustomPopper = function (props: any) {
    return (
      <>
        <div>
          <Popper
            {...props}
            style={{ width: 'fit-content', maxWidth: '300px' }}
            placement="bottom-start"
            disableListWrap={true}
            sx={{
              '& .MuiPaper-root': {
                boxShadow: '0 4px 10px -1px rgb(17 20 24 / 20%)',
              },
            }}
          ></Popper>
        </div>
      </>
    );
  };
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    (async () => {
      await fetchSelectOptions('');
    })();
  };

  const handleClose = () => {
    setOpen(false);
    setSelectOptions([]);
  };

  return (
    <>
      {moreOptions ? (
        <Autocomplete
          open={open}
          onOpen={handleOpen}
          onClose={handleClose}
          sx={{
            '& .MuiAutocomplete-root .MuiAutocomplete-tag': {},
          }}
          fullWidth={true}
          size="small"
          loading={loading}
          PopperComponent={LargePopper}
          multiple
          title={''}
          getOptionKey={(option: any) => option?.id}
          options={selectOptions}
          renderOption={(props: any, option: any) => {
            return (
              <Box
                component="li"
                sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option?.isButton && (
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    size={'small'}
                    fullWidth
                  >
                    Add new
                  </Button>
                )}
                {option?.color && typeof option?.color === 'string' ? (
                  <Chip
                    style={{
                      background: `#${option?.color}`,
                      color: '#fff',
                    }}
                    icon={
                      <ColorizeIcon
                        color={'disabled'}
                        sx={{ color: 'white' }}
                      />
                    }
                    label={`#${option.name}`}
                  />
                ) : (
                  option.name
                )}
              </Box>
            );
          }}
          getOptionLabel={(option) => {
            if (schema?.name.toLowerCase() === 'service price') {
              return `${option?.up_to_person} - ${option?.price}`;
            }
            if (schema?.name.toLowerCase() === 'services') {
              if (option?.service_provider) {
                return (
                  <>
                    <div>{option?.service_provider.name}</div>
                    <div>{option?.name}</div>
                  </>
                );
              }
            }
            return option?.name;
          }}
          isOptionEqualToValue={(option, value) => {
            return false;
          }}
          value={currentState.value ? currentState.value : []}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                size="small"
                label={''}
                InputLabelProps={{
                  style: {
                    fontSize: 13,
                    paddingTop: 2,
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            );
          }}
          disabled={disabled}
          onChange={(event, newValue) => {
            handleOnChange(newValue);
          }}
        />
      ) : (
        <Autocomplete
          open={open}
          onOpen={handleOpen}
          onClose={handleClose}
          sx={{
            '& .MuiAutocomplete-root .MuiAutocomplete-tag': {},
          }}
          fullWidth={true}
          size="small"
          loading={loading}
          PopperComponent={LargePopper}
          multiple
          title={''}
          options={selectOptions}
          getOptionKey={(option: any) => option?.id}
          renderOption={(props: any, option: any) => {
            return (
              <Box
                component="li"
                sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option?.isButton && (
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    size={'small'}
                    fullWidth
                  >
                    Add new
                  </Button>
                )}
                {option?.color && typeof option?.color === 'string' ? (
                  <Chip
                    style={{
                      background: `#${option?.color}`,
                      color: '#fff',
                    }}
                    icon={
                      <ColorizeIcon
                        color={'disabled'}
                        sx={{ color: 'white' }}
                      />
                    }
                    label={`#${option.name}`}
                  />
                ) : (
                  option.name
                )}
              </Box>
            );
          }}
          getOptionLabel={(option) => {
            if (schema?.name.toLowerCase() === 'service price') {
              return `${option?.up_to_person} - ${option?.price}`;
            }
            if (schema?.name.toLowerCase() === 'services') {
              if (option?.service_provider) {
                return (
                  <>
                    <div>{option?.service_provider.name}</div>
                    <div>{option?.name}</div>
                  </>
                );
              }
            }
            return option?.name;
          }}
          isOptionEqualToValue={(option, value) => {
            if (!option?.id) return false;
            return option.id === value.id;
          }}
          value={currentState.value ? currentState.value : []}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                size="small"
                label={''}
                InputLabelProps={{
                  style: {
                    fontSize: 13,
                    paddingTop: 2,
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            );
          }}
          disabled={disabled}
          renderTags={(value, getTagProps, label: any) => {
            return value.map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                label={label.getOptionLabel(option)}
                key={`chip-item-${index}`}
                id={`chip-item-${index}`}
                sx={{
                  '& .MuiChip-label': {
                    paddingRight: '6px',
                  },
                  height: 'auto',
                  minHeight: '32px',
                  lineHeight: '20px',
                }}
                deleteIcon={
                  <>
                    {!disabled && (
                      <>
                        <IconButton
                          key={`chip-edit-button-${option?.id}-${index}`}
                          id={`chip-edit-button-${option?.id}-${index}`}
                          aria-label="edit"
                          size="small"
                          color={'primary'}
                          onClick={(event: any) => {
                            if (event?.target?.nodeName === 'BUTTON') {
                              return false;
                            }
                            console.log('You clicked the edit button');

                            setOpenedSlidingPane({
                              schema: schema,
                              row: option,
                            });
                            return true;
                          }}
                          sx={{
                            padding: '0px',
                            '& .MuiSvgIcon-root': {
                              width: '15px',
                              height: '15px',
                            },
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          key={`chip-delete-button-${option?.id}-${index}`}
                          id={`chip-delete-button-${option?.id}-${index}`}
                          aria-label="delete"
                          size="small"
                          color={'error'}
                          sx={{
                            padding: '0px',
                            paddingRight: '8px',
                            '& .MuiSvgIcon-root': {
                              width: '15px',
                              height: '15px',
                            },
                          }}
                          onClick={(event) => {
                            const newValue = value.filter(
                              (item: any) => item.id !== option.id
                            );
                            handleOnChange(newValue);
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </>
                    )}
                  </>
                }
              />
            ));
          }}
          onChange={(event, newValue) => {
            handleOnChange(newValue);
          }}
        />
      )}

      {openedSlidingPane?.row?.id && (
        <SlidingPaneEdit
          schema={openedSlidingPane?.schema}
          id={openedSlidingPane?.row?.id}
          onSubmit={(value) => {
            const tempValue = currentState.value ? [...currentState.value] : [];

            const newValue = tempValue.map((item: any) => {
              return item?.id === value?.id ? value : item;
            });
            setOpenedSlidingPane({});
            setCurrentState({
              value: newValue,
              send: false,
            });
          }}
          propertiesFromTable={
            openedSlidingPane?.row ? openedSlidingPane?.row : {}
          }
          onClose={(value) => {
            setOpenedSlidingPane({});
          }}
        />
      )}

      {addingEntity && (
        <SlidingPaneAddNew
          schema={schema}
          mainSchema={schema}
          id={'new'}
          hasSlidingPane={false}
          onSubmit={(value: any) => {
            if (value) {
              const tempValue = currentState.value
                ? [...currentState.value]
                : [];
              tempValue.push(value);
              setCurrentState({
                value: tempValue,
                send: true,
              });
              setAddingEntity(false);
            }
          }}
          propertiesFromTable={allValue}
          row={{}}
          onClose={(value) => {
            setAddingEntity(false);
          }}
        />
      )}
    </>
  );
};

SPSetField.tableAdapter = <T extends NamedEntity = NamedEntity>(
  schema: SchemaWithClient<T>,
  moreOptions?: boolean
) => {
  const Field: FieldComponent<T[], T[]> = ({
    onChange,
    isActive: active,
    defaultValue,
    forcedValue,
    disabled,
    isMissing,
    mainSchema,
    column,
    accordingToValue,
    allValue,
  }) => (
    <SPSetField
      onChange={onChange}
      defaultValue={defaultValue}
      forcedValue={forcedValue}
      disabled={!!disabled}
      isMissing={!!isMissing}
      schema={schema}
      mainSchema={mainSchema}
      column={column}
      accordingToValue={accordingToValue}
      allValue={allValue}
      moreOptions={moreOptions}
    />
  );

  Field.includes = () => false;
  Field.comparator = () => 0;

  Field.FilterRenderer = (props) => {
    return (
      <>
        <Field {...props} isActive />
      </>
    );
  };

  return Field;
};
